import { BlogEntityTypeEnum, PostSortTypeEnum } from '@/fo/api/magento';
import { SortOptionEnum } from '@/fo/ui/article/list/base';

import { BlogPageTopic, BlogPageType } from './types';

export const POSTS_PAGE_SIZE = 9;
export const BANNER_PAGE_SIZE = 3;
export const TOPICS_SORT_TYPE = PostSortTypeEnum.Latest;

export const sortMap = {
  [SortOptionEnum.Popular]: PostSortTypeEnum.Popular,
  [SortOptionEnum.Newest]: PostSortTypeEnum.Latest,
  [SortOptionEnum.WithNaos]: PostSortTypeEnum.WithDoctor
};

export const topicsUrlMap = {
  [BlogPageTopic.TopFive]: `/about-skin/articles/topics/${BlogPageTopic.TopFive}`,
  [BlogPageTopic.Wellness]: `/about-skin/news/topics/${BlogPageTopic.Wellness}`,
  [BlogPageTopic.Interview]: `/about-skin/videos/topics/${BlogPageTopic.Interview}`
};

export const urlMap = {
  [BlogPageType.Article]: 'articles',
  [BlogPageType.News]: 'news',
  [BlogPageType.Video]: 'videos'
};

export const typeMap = {
  [BlogPageType.Article]: BlogEntityTypeEnum.Article,
  [BlogPageType.News]: BlogEntityTypeEnum.News,
  [BlogPageType.Video]: BlogEntityTypeEnum.ExpertVideo
};

export const entityTypeToPageType: Record<BlogEntityTypeEnum, BlogPageType> = {
  [BlogEntityTypeEnum.Article]: BlogPageType.Article,
  [BlogEntityTypeEnum.News]: BlogPageType.News,
  [BlogEntityTypeEnum.ExpertVideo]: BlogPageType.Video
};

export const bannersMap = {
  [BlogPageType.Article]: 'banner_seo_blog_articles',
  [BlogPageType.News]: 'banner_seo_blog_news',
  [BlogPageType.Video]: 'banner_seo_blog_video'
};
